// SPDX-License-Identifier: AGPL-3.0-or-later

import {CallMessage} from '@app/features/channel/components/CallMessage';
import {ChannelIconChangeMessage} from '@app/features/channel/components/ChannelIconChangeMessage';
import {ChannelNameChangeMessage} from '@app/features/channel/components/ChannelNameChangeMessage';
import {GuildJoinMessage} from '@app/features/channel/components/GuildJoinMessage';
import {PinSystemMessage} from '@app/features/channel/components/PinSystemMessage';
import {RecipientAddMessage} from '@app/features/channel/components/RecipientAddMessage';
import {RecipientRemoveMessage} from '@app/features/channel/components/RecipientRemoveMessage';
import {UnknownMessage} from '@app/features/channel/components/UnknownMessage';
import {UserMessage} from '@app/features/channel/components/UserMessage';
import type {Channel} from '@app/features/channel/models/Channel';
import type {Message} from '@app/features/messaging/models/Message';
import Users from '@app/features/user/state/Users';
import {MessageTypes} from '@app/vendor/constants/ChannelConstants';
import type React from 'react';
export function getMessageComponent(
	message: Message,
	_channel: Channel,
	forceUnknownMessageType = false,
): React.ReactElement {
	const currentUser = Users.getCurrentUser();
	if (forceUnknownMessageType && currentUser && message.author.id === currentUser.id) {
		return <UnknownMessage />;
	}
	switch (message.type) {
		case MessageTypes.USER_JOIN:
			return <GuildJoinMessage message={message} />;
		case MessageTypes.CHANNEL_PINNED_MESSAGE:
			return <PinSystemMessage message={message} />;
		case MessageTypes.RECIPIENT_ADD:
			return <RecipientAddMessage message={message} />;
		case MessageTypes.RECIPIENT_REMOVE:
			return <RecipientRemoveMessage message={message} />;
		case MessageTypes.CALL:
			return <CallMessage message={message} />;
		case MessageTypes.CHANNEL_NAME_CHANGE:
			return <ChannelNameChangeMessage message={message} />;
		case MessageTypes.CHANNEL_ICON_CHANGE:
			return <ChannelIconChangeMessage message={message} />;
		case MessageTypes.DEFAULT:
		case MessageTypes.REPLY:
		case MessageTypes.CLIENT_SYSTEM:
			return <UserMessage />;
		default:
			return <UnknownMessage />;
	}
}
